import { createAction, createReducer } from '@reduxjs/toolkit'

// ACTIONS
const stepEnableFocus = createAction('step/enablefocus')
const stepDisableFocus = createAction('step/disablefocus')

const enablePrimaryButton = createAction('step/enablePrimaryButton')
const togglePrimaryButton = createAction('step/togglePrimaryButton')
const setModalOpenState = createAction('step/setModalOpen')
const setSidebarActiveModalKeyState = createAction('step/setSidebarActiveModalKey')
const requestSidebarModalState = createAction('step/requestSidebarModal')
const clearSidebarModalRequestState = createAction('step/clearSidebarModalRequest')
const requestReportsModalTabState = createAction('step/requestReportsModalTab')
const clearReportsModalTabRequestState = createAction('step/clearReportsModalTabRequest')

const stepEnableFacilitatorGraphics = createAction('step/enableFacilitatorGraphics')
const stepDisableFacilitatorGraphics = createAction('step/disableFacilitatorGraphics')

const showBottomBar = createAction('step/showBottomBar')

// REDUCER
export const initialState = {
  focus: false,
  enabledPrimaryButton: true,
  modalOpen: false,
  sidebarActiveModalKey: null,
  /** One-shot: consumed by RightSidebar to open a modal with options (e.g. initial tab). */
  sidebarModalRequest: null,
  /** One-shot: consumed by ReportsModalView to switch tab after mount (e.g. Robotutor handoff). */
  reportsModalTabRequest: null,
  enableFacilitatorGraphics: false,
  showBottomBar: true
}

const stepReducer = createReducer(initialState, {
  [stepEnableFocus.type]: (state) => {
    state.focus = true
  },
  [stepDisableFocus.type]: (state) => {
    state.focus = false
  },
  [enablePrimaryButton.type]: (state, action) => {
    state.enabledPrimaryButton = action.payload
  },
  [togglePrimaryButton.type]: (state) => {
    state.enabledPrimaryButton = !state.enabledPrimaryButton
  },
  [setModalOpenState.type]: (state, action) => {
    state.modalOpen = action.payload
  },
  [setSidebarActiveModalKeyState.type]: (state, action) => {
    state.sidebarActiveModalKey = action.payload
  },
  [requestSidebarModalState.type]: (state, action) => {
    state.sidebarModalRequest = action.payload
  },
  [clearSidebarModalRequestState.type]: (state) => {
    state.sidebarModalRequest = null
  },
  [requestReportsModalTabState.type]: (state, action) => {
    state.reportsModalTabRequest = action.payload
  },
  [clearReportsModalTabRequestState.type]: (state) => {
    state.reportsModalTabRequest = null
  },
  [stepEnableFacilitatorGraphics.type]: (state) => {
    state.enableFacilitatorGraphics = true
  },
  [stepDisableFacilitatorGraphics.type]: (state) => {
    state.enableFacilitatorGraphics = false
  },
  [showBottomBar.type]: (state, action) => {
    state.showBottomBar = action.payload
  }
})

export default stepReducer

// PUBLIC ACTIONS
export const enableFocus = () => (dispatch) => {
  dispatch(stepEnableFocus())
}

export const disableFocus = () => (dispatch) => {
  dispatch(stepDisableFocus())
}

export const setEnablePrimaryButton = (value) => (dispatch) => {
  dispatch(enablePrimaryButton(value))
}

export const toggleEnablePrimaryButton = () => (dispatch) => {
  dispatch(togglePrimaryButton())
}

export const setModalOpen = (value) => (dispatch) => {
  dispatch(setModalOpenState(value))
}

export const setSidebarActiveModalKey = (key) => (dispatch) => {
  dispatch(setSidebarActiveModalKeyState(key))
}

export const requestSidebarModal = (payload) => (dispatch) => {
  dispatch(requestSidebarModalState(payload))
}

export const clearSidebarModalRequest = () => (dispatch) => {
  dispatch(clearSidebarModalRequestState())
}

export const requestReportsModalTab = (tab) => (dispatch) => {
  dispatch(requestReportsModalTabState(tab))
}

export const clearReportsModalTabRequest = () => (dispatch) => {
  dispatch(clearReportsModalTabRequestState())
}

export const enableFacilitatorGraphics = () => (dispatch) => {
  dispatch(stepEnableFacilitatorGraphics())
}

export const disableFacilitatorGraphics = () => (dispatch) => {
  dispatch(stepDisableFacilitatorGraphics())
}

export const setShowBottomBar = (value) => (dispatch) => {
  dispatch(showBottomBar(value))
}
